import React from 'react';
import styled, { css } from 'styled-components';
import { withRouter } from 'react-router';
import { Flex } from '@catalogo/theme-layout';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import { FreightIcon } from '@catalogo/ui-americanas-mobile-freight/src/components/freight-icon';

const Wrapper = styled.div`
  margin-top: 16px;
  display: block;
  justify-content: space-between;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CellIcon = styled(Flex)`
  align-items: center;
`;

const Cell = styled.div``;

const Button = styled.button`
  ${({ theme }) => css`
    background: transparent;
    border: 2px solid ${theme.primaryColor};
    display: flex;
    font-weight: bold;
    color: ${theme.primaryColor};
    text-transform: ${theme.btnTextTransform};
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    padding: 10px;
    justify-content: center;
    width: 100%;
  `}
`;

const Badge = styled.div`
  ${({ theme }) => css`
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    color: ${theme.grey.dark};
    width: 65px;
    border: 1px solid ${theme.grey.dark};
    border-radius: 12px;
    text-align: center;
  `}
`;

const TypeText = styled.p`
  margin-top: 5px;
  margin-left: 30px;
`;

const Strong = styled.span`
  font-weight: bold;
`;

const SupportTextUI = styled.p`
  font-size: 12px;
  margin-top: 10px;
  margin-left: 30px;
`;

const LasaOffer = ({ lasaOfferData, history }) => {
  if (!lasaOfferData) {
    return null;
  }

  return (
    <Wrapper>
      <Container>
        <Cell>
          <CellIcon>
            <FreightIcon />
            <Badge>loja física</Badge>
          </CellIcon>
          <TypeText>
            <Strong>{lasaOfferData?.deadline?.bold}</Strong>
            {lasaOfferData?.deadline?.normalWeight}
          </TypeText>
        </Cell>
        <Cell>
          <Button
            onClick={replaceUrlParams(history, '#modal-select-store', false, { text: lasaOfferData?.deadline?.bold })}
          >
            quero!
          </Button>
        </Cell>
      </Container>
      <SupportTextUI>
        *compre por <Strong>{lasaOfferData?.disclaimer?.price}</Strong>
        {lasaOfferData?.disclaimer?.normalWeight}
      </SupportTextUI>
    </Wrapper>
  );
};

export default withRouter(LasaOffer);
